import { authFetch } from "../../../../../../authFetch";


export const transferStudent = async (requestData) => {
    try {
        const res = await authFetch(`route2.0/transfer-student`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify( requestData ),
        });

        const data = await res.json();
        return data;
    } catch (err) {
        console.error(err);
    }
};


export const gettransferStudentList = async (requestData) => {
    try {
        const res = await authFetch(`route/students-transfer-list`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify( requestData ),
        });

        const data = await res.json();
        return data;
    } catch (err) {
        console.error(err);
    }
}